import React from 'react'
import { StyleSheet, Text, View } from 'react-native'
import Icon from '../../Icon'
import styles, { colors } from '../../styles/global'
import ParentGoalWrapper from './ParentGoalWrapper'
import { translate } from '../../../i18n/TranslationService'
import SuggestedGoalTag from '../../Tags/SuggestedGoalTag'
import { hasPendingGoalSuggestion } from '../../../utils/TaskGoalSuggestion'

export default function ParentGoal({ projectId, task, disabled }) {
    return (
        <View style={localStyles.container}>
            <View style={{ marginRight: 8 }}>
                <Icon name="target" size={24} color={colors.Text03} />
            </View>
            <Text style={[styles.subtitle2, { color: colors.Text03 }]}>{translate('Goal')}</Text>
            <View style={{ marginLeft: 'auto' }}>
                {hasPendingGoalSuggestion(task) ? (
                    <SuggestedGoalTag projectId={projectId} task={task} disabled={disabled} propertyButton />
                ) : (
                    <ParentGoalWrapper projectId={projectId} task={task} disabled={disabled} />
                )}
            </View>
        </View>
    )
}

const localStyles = StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: 'row',
        maxHeight: 56,
        minHeight: 56,
        height: 56,
        paddingLeft: 8,
        paddingVertical: 8,
        alignItems: 'center',
    },
})
